export default __webpack_public_path__ + "87f275692c66e37e86543c018e67aeda.png";